<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <form data-vv-scope="Ecollage" @submit.prevent="Ecollage_validate">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 md:w-2/3 sm:w-1/2 w-full mb-2">
            <p> {{ $t('Student') }} <b style="color: #ff6141;">*</b> </p>

            <v-select
              :options="inscriptions"
              @search="getInscription"
              :clearable="true"
              :getOptionLabel="getOptionLabel"
              v-model="inscriptionEleveSelectionner"
              class="w-full" name="inscription" v-validate="'required'"/>
            <span class="text-danger">{{ errors.first('Ecollage.inscription') }}</span>

          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full mb-2">
            <vs-button class="mt-4 ml-5" @click="Ecollage_validate" color="success" type="border" icon-pack="feather" icon="icon-save" :disabled="!isOk">{{ $t("Submit") }}</vs-button>
          </div>
        </div>
        <div class="export-table">
          <vs-table :data="fraisInscriptions">
            <template slot="thead">
              <vs-th>{{ $t("type_of_fees") }}</vs-th>
              <vs-th>{{ $t("Total_amount") }}</vs-th>
              <vs-th> Total Payer </vs-th>
              <vs-th>{{ $t("Remaining_mount") }}</vs-th>
              <vs-th>{{ $t("Amount_to_pay") }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.typeFrais }}</vs-td>
                <vs-td style="text-align: right;">
                  <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.montantTotal) }}</p>
                </vs-td>
                <vs-td style="text-align: right;">
                  <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.totalPayer) }}</p>
                </vs-td>
                <vs-td style="text-align: right;">
                  <p class="product-name font-medium truncate">{{ new Intl.NumberFormat('de-DE').format(tr.reste) }}</p>
                </vs-td>
                <vs-td>
                  <!-- <vs-input-number class="ml-0 w-full" v-model="tr.frais.payAmount" v-validate="{ max_value: tr.reste, min_value:0 }" :name="'valeur' + indextr"/> -->
                  <vs-input
                    v-if="tr.reste"
                    v-model="tr.montant"
                    class="w-full"
                    v-validate="{ decimal: true, max_value: tr.reste, min_value: 0 }"
                    :name="'valeur' + indextr" />
                  <span class="text-danger text-sm">{{ errors.first('Ecollage.valeur' + indextr) }}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </form>

    <vx-card class="mt-8">
      <vs-tabs v-if="fraisInscriptions.length">
        <vs-tab :label="tr.typeFrais" icon-pack="feather" :icon="indextr < icons.length ? icons[indextr] : icons[0]" :key="indextr" v-for="(tr, indextr) in fraisInscriptions">
          <receipts :idInscription="tr.inscription" :idTypeFrais="tr.idTypeFrais" :frais="tr.frais"/>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
let base_self = ''
const input_tempon = {
  id: null,
  inscription: '',
  typeFrais: '',
  montant: ''
}

import { Validator } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'

import receipts from '../receipts/principal.vue'

export default {
  components: { flatPickr, Datepicker, receipts },
  data () {
    return {
      icons: ['icon-home', 'icon-box', 'icon-mail', 'icon-heart'],
      selected: [],
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      presenceObject: {},
      presences: [],
      fraisInscriptions: [],
      label: ['eleve', 'full_name'],
      paramFraisInscritption: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      paramFrais: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          anneeScolaire__encours: true,
          anneeScolaire__cloture: false,
          typeFrais__state: true,
          q_list: []
        }
      },
      paramInscription: {
        is_get: true,
        paginate: {
          length: 10,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false,
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['eleve__full_name'],
        juste: {
          id: '',
          eleve: {
            id: '',
            full_name: ''
          },
          statutEleve: {
            id: ''
          },
          salle: {
            libelle: '',
            classe: {
              id: ''
            }
          },
          anneeScolaire: {
            id: ''
          }
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      professeurClasseMatieres: [],
      professeurClasseMatieres1: [],
      inscriptionEleveSelectionner: '',
      inscriptions: [],
      inscriptions1: [],
      partitions: [],
      partitions1: [],
      frais: [],
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    inscriptionEleveSelectionner (value) {
      // console.log('value: ', value)
      base_self.input.inscription = JSON.parse(JSON.stringify(value))
      base_self.getFraisSimple(value)
    }
  },
  computed: {
    isOk () {
      let ok = false
      const length = base_self.fraisInscriptions.length
      for (let i = 0; i < length; i++) {
        if (base_self.fraisInscriptions[i].montant) {
          ok = true
          break
        }
      }
      return ok
    }
  },
  methods: {
    getRecu (fraisInscriptions) {
      for (let i = 0; i < fraisInscriptions.length; i++) {
        const item = fraisInscriptions[i]
        base_self.imprimerRecu(item.inscription, item.frais)
      }
    },
    imprimerRecu (inscription, frais) {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/imprimer-recu-direct/${inscription}/${frais}`, '_blank')
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {
        // const length = this.label.length

        
        return `${option.eleve.full_name} ( ${option.salle.libelle} )`
        /* for (let i = 0; i < length; i++) {
          if (element && !element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }

          element = element ? element[this.label[i]] : ''
        } */

        // return option['created_at']
        
      }
      return option
    },
    /* getFraisInscritptionSimple () {

      base_self.paramFraisInscritption.filter['frais__classe__id'] = base_self.input.inscription.salle.classe.id
      base_self.paramFraisInscritption.filter['frais__anneeScolaire__id'] = base_self.input.inscription.anneeScolaire.id
      base_self.paramFraisInscritption.filter['frais__statutEleves__id'] = base_self.input.inscription.statutEleve.id
      base_self.paramFraisInscritption.filter['inscription__id'] = base_self.input.inscription.id

      base_self.$http.post(`${base_self.$store.state.route_for_esm}FraisInscritption`, base_self.paramFraisInscritption)
        .then((response) => {
          base_self.fraisInscriptions = JSON.parse(JSON.stringify(response.data.data))

          if (!response.data.data.length) {
            base_self.getFraisSimple()
            base_self.initialisationForNotes(response.data.data)
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }, */
    async getFraisSimple (value) {
      /*
        class FraisInscritption(TimespamtedModel):
          payer: 0,
          reste: ,
          enRegle: false

          inscription = models.ForeignKey('Inscription', related_name='fraisInscriptions', null=True, blank=True, on_delete=models.CASCADE)
          frais = models.ForeignKey('Frais', related_name='fraisInscriptions', null=True, blank=True, on_delete=models.CASCADE)
      */
      base_self.paramFrais.filter['classe__id'] = value.salle.classe.id
      base_self.paramFrais.filter['anneeScolaire__id'] = value.anneeScolaire.id
      base_self.paramFrais.filter['statutEleves__id'] = value.statutEleve.id

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Frais`, base_self.paramFrais)
        .then(async (response) => {
          const fraisInscriptions = []

          const length = response.data.data.length
          for (let i = 0; i < length; i++) {
            let totalPayer = 0

            const data3 = {
              is_get: true,
              paginate: {
                length: 100,
                page: 1
              },
              filter: {
                frais__id: response.data.data[i].id,
                inscription__id: base_self.input.inscription.id,
                annuler: false
              },
              juste: {
                montant: ''
              }
            }

            const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Recu`, data3)
              .catch((error) => {
                console.log('error: ', error)
              })

            const length_3 = response_3.data.data.length
            for (let uioy = 0; uioy < length_3; uioy++) {
              totalPayer += response_3.data.data[uioy].montant
            }

            const estPresent = fraisInscriptions.find(c => c.id === response.data.data[i].typeFrais.id)
            
            if (!estPresent) {
              fraisInscriptions.push({
                id: response.data.data[i].typeFrais.id,
                idTypeFrais: response.data.data[i].typeFrais.id,
                typeFrais: response.data.data[i].typeFrais.libelle,
                inscription: base_self.input.inscription.id,
                frais: response.data.data[i].id,
                annuler: false,
                dateDePaiement: new Date(),
                montant: 0,
                montantTotal: response.data.data[i].montant,
                totalPayer,
                reste: response.data.data[i].montant - totalPayer
              })
            }
          }

          console.log(' :::::::::::::::::::::::::::::::::::::: Je suis simple mais je me demande si j\'y serai :::::::::::::::::::::::::::::::::::::: ')
          console.log(' :::::::::::::::::::::::::::::::::::::: Je suis simple mais je me demande si j\'y serai :::::::::::::::::::::::::::::::::::::: ')
          console.log(' :::::::::::::::::::::::::::::::::::::: Je suis simple mais je me demande si j\'y serai :::::::::::::::::::::::::::::::::::::: ')
          console.log('fraisInscriptions: ', fraisInscriptions)

          base_self.fraisInscriptions = fraisInscriptions
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    async initialisationForNotes (inscriptions) {
      const dict = {
        custom: {
          professeurClasseMatiere: {
            required: base_self.$t('The_matter_by_teachers_is_required')
          },
          valeur: {
            required:
              'Le champ valeur doit être numérique et peut contenir des points décimaux'
          },
          partition: {
            required: base_self.$t('The_partition_is_required')
          },
          datePresence: {
            required: base_self.$t('The_date_is_required')
          },
          heureDebut: {
            required: base_self.$t('The_start_time_is_required')
          },
          heureFin: {
            required: base_self.$t('The_end_time_is_required')
          }
        }
      }

      const length = inscriptions.length
      for (let i = 0; i < length; i++) {
        dict.custom[`valeur${i}`] = {
          max_value: base_self.$t('This_field_must_be_less_or_equal_to_the_remaining_amount'),
          min_value: base_self.$t('This_field_must_be_0_or_more')
        }
      }
      Validator.localize('en', dict)
    },

    async getFraisInscriptions () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          frais__typeFrais__id: base_self.input.typeFrais
        }
      }
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}FraisInscritption`,
          data,
        )
        .then((response) => {
          console.log('data fr', response.data.data)
          base_self.fraisInscriptions = JSON.parse(
            JSON.stringify(response.data.data),
          )
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getInscriptionSimple () {
      delete base_self.paramInscription.filter['eleve__full_name__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))

          console.log('base_self.inscriptions: ', base_self.inscriptions)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getInscription (search, loading) {
      loading(true)
      base_self.paramInscription.filter['eleve__full_name__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    Ecollage_validate () {
      base_self.$validator.validateAll('Ecollage').then((result) => {
        if (result) {
          base_self.submitData()
        }
      })
    },
    async submitData () {
      //const input = JSON.parse(JSON.stringify(base_self.input))
      base_self.$vs.loading()

      const fraisInscriptions = JSON.parse(JSON.stringify(base_self.fraisInscriptions))

      console.log('fraisInscriptions: Début', fraisInscriptions)
      
      for (let i = 0; i < fraisInscriptions.length; i++) {
        if (!fraisInscriptions[i].montant) {
          fraisInscriptions.splice(i, 1)
          i--
        } else {
          fraisInscriptions[i].dateDePaiement = new Date()
        }
      }

      console.log('fraisInscriptions: Fin', fraisInscriptions)

      const data = {
        many: true,
        data: fraisInscriptions
      }
      
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Recu`, data)
        .then((response) => {
          base_self.getFraisSimple(base_self.input.inscription)

          base_self.getRecu(fraisInscriptions)

          console.log('response ', response)
          window.getESM.success(base_self.$t('The_payment_is_added_successfully'), response)
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          console.log('error Update FraisInscription: ', error)
          base_self.$vs.loading.close()
        })
    },
    initValues () {
      base_self.$validator.errors.clear()
    }
  },
  async created () {
    base_self = this

    base_self.getInscriptionSimple()

    ///////////////////////////
    const dict = {
      custom: {
        professeurClasseMatiere: {
          required: base_self.$t('The_matter_by_teachers_is_required')
        },
        inscription: {
          required: base_self.$t('The_Student_is_required')
        },
        typeEcollage: {
          required: base_self.$t('The_type_examen_is_required')
        },
        partition: {
          required: base_self.$t('The_partition_is_required')
        },
        datePresence: {
          required: base_self.$t('The_date_is_required')
        },
        heureDebut: {
          required: base_self.$t('The_start_time_is_required')
        },
        heureFin: {
          required: base_self.$t('The_end_time_is_required')
        }
      }
    }
    Validator.localize('en', dict)
    //////////////////////////
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .flatpickr-input,
[dir] .flatpickr-input[type='hidden'] + input {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
